import PropTypes from 'prop-types'
import React from 'react'

import { H2 } from 'styles/components/typography'

import { calcDiff } from '../utils'

import Bars from './components/Bars'
import { Wrapper, DifferenceBox, Diff, DifferenceInner } from './styles'

const WAboutCompareDetailsTablet = ({ data, isTablet }) => {
  const dataLength = data.length - 1

  return data.map((item, index) => (
    <Wrapper isLast={index === dataLength} key={`key-${index}`}>
      <DifferenceBox>
        <DifferenceInner>
          <Diff
            dangerouslySetInnerHTML={{
              __html: `+${calcDiff(item.wgs_indicators, item.dna_indicators)}`,
            }}
          />
          <H2 as="span" dangerouslySetInnerHTML={{ __html: item.text }} />
        </DifferenceInner>
      </DifferenceBox>

      <Bars {...{ isTablet, item }} />
    </Wrapper>
  ))
}

WAboutCompareDetailsTablet.propTypes = {
  data: PropTypes.array.isRequired,
  isTablet: PropTypes.bool,
}

WAboutCompareDetailsTablet.defaultProps = {
  isTablet: false,
}

export default WAboutCompareDetailsTablet
